/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILike {
  /** Кол. дизлайков **/
  dislikesCount: number;
  /** Кол. лайков **/
  likesCount: number;
  /** Наличие лайка/дизлайка от текущего пользователя **/
  status: EStatus;
}

export enum EStatus {
  /** Поставлен дизлайк **/
  'Disliked' = 'disliked',
  /** Поставлен лайк **/
  'Liked' = 'liked',
  /** Нет реакции **/
  'Unknown' = 'unknown',
}
